import React, { useContext } from "react"
import { Button, IconButton, Dialog, DialogTitle, Slide, DialogContent, Typography, DialogActions } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import useMutation from "../hooks/useMutation"
import UserContext from "../context/UserContext"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeleteAccountDialog = ({ handleClose, onConfirm }) => {
  const { userData } = useContext(UserContext)
  const { email } = userData.user

  const { mutate, loading } = useMutation("/user", "DELETE")

  const handleSend = async () => {
    handleClose()

    await mutate({
      ...userData.user,
    })

    onConfirm()
  }

  return (
    <Dialog TransitionComponent={Transition} onClose={handleClose} open>
      <DialogTitle>
        Account löschen
        <IconButton sx={{ position: "absolute", right: "1vw", top: "1vh" }} onClick={handleClose}>
          <CloseIcon color="secondary" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2">Möchtest du deinen Account löschen?</Typography>

        <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
          <u>Wenn du deinen Account löschst, kannst du nicht mehr:</u>
        </Typography>
        <Typography variant="body2">
          ● Bücher kaufen
          <br />
          ● Bücher verkaufen
          <br />● Mit Käufern und Verkäufern chatten
        </Typography>

        <Typography variant="body2" sx={{ mt: 2 }}>
          <b>Wichtig:</b> Mit der E-Mail Adresse {email} wirst du dich nicht mehr registrieren können.
        </Typography>

        <Typography variant="body2" sx={{ mt: 2 }}>
          Auch wenn du deinen Account nicht löschst, werden deine Daten am Ende des Schuljahres gelöscht.
        </Typography>

        <Typography variant="body2" sx={{ mt: 2 }}>
          Wenn du eine Frage oder ein Problem hast, kannst du uns auch direkt über support@bookay-buecher.de kontaktieren.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          Abbrechen
        </Button>

        <Button disabled={loading} onClick={handleSend} color="secondary">
          Account löschen
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteAccountDialog
